// Generated types for SysMLUsage
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLFeatureReadAPI, SysMLFeatureWriteAPI } from './sysmlfeature';
import { SysMLFeatureReadAPISchemaObject, SysMLFeatureWriteAPISchemaObject } from './sysmlfeature';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLUsageReadAPI extends SysMLFeatureReadAPI {
}

export interface SysMLUsageWriteAPI extends SysMLFeatureWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLUsageReadAPISchemaObject = SysMLFeatureReadAPISchemaObject.extend({}).passthrough();
export const SysMLUsageReadAPISchema: z.ZodType<SysMLUsageReadAPI> = SysMLUsageReadAPISchemaObject;

export const SysMLUsageWriteAPISchemaObject = SysMLFeatureWriteAPISchemaObject.extend({}).passthrough();
export const SysMLUsageWriteAPISchema: z.ZodType<SysMLUsageWriteAPI> = SysMLUsageWriteAPISchemaObject;
